<template>
  <a-modal
    :title="modalTit"
    :visible.sync="isLimitDialogShow"
    width="490px"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    class="edit-limit-dialog create-project-dialog"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="submitHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="creat-dilog-form">
      <a-form
        ref="createForm"
        :form="form"
        :hide-required-mark="true"
        class="demo-form-inline"
      >
        <a-form-item
          :label="`${orgTit}：`"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
          class="total-input-box"
        >
          <a-input
            v-decorator="['comname', { rules: [
              { required: true, message: comnamePlace, trigger: 'blur' }
            ] ,initialValue: orgItemData.comname}]"
            maxlength="20"
            type="text"
            :placeholder="comnamePlace"
          />
          <span class="input-length-num">{{ form.getFieldValue('comname')?form.getFieldValue('comname').length : 0 }}/20</span>
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  props: {
    orgItemData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  computed: {
    comnamePlace () {
      return this.$t('message["843"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    },
    modalTit () {
      return this.$t('message["1403"]')
    },
    orgTit () {
      return this.$t('message["1677"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    ...mapActions('organization/org', ['ajaxEditOrg']),
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    submitHandle (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const formDatas = Object.assign(values, { cid: this.orgItemData.cid })
          const chain = await this.ajaxEditOrg({ cid: this.orgItemData.cid })
          chain.params(formDatas)
            .setForm(this.form)
            .fetch()
          this.form.resetFields()
          this.isLimitDialogShow = false
        }
      })
    }
  }
}
</script>
<style scoped>
.input-length-num {
  position: absolute;
  right: 6px;
  top: -8px;
}
</style>
